import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'
import { LayoutAppElementComponent } from './layout_app_element/layout-app-element.component'
import { LayoutAppElementDetailComponent } from './layout-app-element-detail/layout-app-element-detail.component'
import { LayoutAppClientDetailComponent } from './layout-app-client-detail/layout-app-client-detail.component'

const routes: Routes = [
    { path: '', component: LayoutAppElementComponent },
    { path: '', component: LayoutAppElementDetailComponent },
    { path: '', component: LayoutAppClientDetailComponent },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class AppElementRouting {

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/appElement.routing.ts